import React, {useEffect, useRef, useState} from "react";
import {withRouter} from "react-router";
import {sortTypes} from "./SortTypes";

function SortSelect(props) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const currentSortType =
        new URLSearchParams(props.location.search).get("sortingType") || sortTypes[8].value;

    const handleSelect = (value) => {
        const urlSearchParams = new URLSearchParams(props.location.search);
        urlSearchParams.set("sortingType", value);
        props.history.push({pathname: props.location.pathname, search: urlSearchParams.toString()});
        setOpen(false);
    };

    useEffect(() => {
        if (!open) return;
        const handleOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleOutside);
        return () => document.removeEventListener("mousedown", handleOutside);
    }, [open]);

    return (
        <div className={"sort-select" + (open ? " sort-select--open" : "")} ref={ref}>
            <button
                type="button"
                className="sort-select__trigger"
                onClick={() => setOpen(!open)}
            >
                <span>SORTUJ WG</span>
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1l4 4 4-4" stroke="#176fb7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>

            {open && (
                <div className="sort-select__panel">
                    {sortTypes.map(st => (
                        <div
                            key={st.value}
                            className={"sort-select__option" + (st.value === currentSortType ? " sort-select__option--active" : "")}
                            onClick={() => handleSelect(st.value)}
                        >
                            {st.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default withRouter(SortSelect);
